/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_MS_BROWSER = exports.IS_IE = exports.IS_FF = exports.IS_EDGE = void 0;
var _getGlobal = require("../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var ua = globalObject.navigator ? globalObject.navigator.userAgent || '' : '';
var IS_EDGE = ua.indexOf('Edge/') !== -1;
exports.IS_EDGE = IS_EDGE;
var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
exports.IS_MS_BROWSER = IS_MS_BROWSER;
var IS_IE = IS_MS_BROWSER && !IS_EDGE;
exports.IS_IE = IS_IE;
var IS_FF = ua.toLowerCase().indexOf('firefox') > -1;
exports.IS_FF = IS_FF;